<script setup>
import { ref, computed, watch } from 'vue';
import store from '@/store';
import service from '@/service';
import LangDrawer from '@/component/LangDrawer.vue';
import menuImg from '@/asset/img/menu.png';

const headerLogo = ref('');
const getHeaderLogo = async () => {
  const res = await service.getLogonLogo();
  const reader = new FileReader();
  reader.onload = e => {
    headerLogo.value = e.target.result;
  };
  reader.readAsDataURL(res.data);
};

const employeeLogoMobile = computed(() => store.state.loginInfo.employeeLogoMobile);
watch(employeeLogoMobile, val => {
  if (val) {
    headerLogo.value = val;
  } else {
    getHeaderLogo();
  }
});

const showDrawer = ref(false);
</script>
<template>
  <div>
    <div class="header h-11 pl-5 flex justify-between items-center">
      <div class="h-6">
        <img class="max-w-full max-h-full align-middle" :src="headerLogo" alt />
      </div>
      <div class="px-4 h-full flex items-center cursor-pointer" @click="showDrawer = true">
        <img class="w-6" :src="menuImg" alt />
      </div>
    </div>
    <lang-drawer :visible.sync="showDrawer"></lang-drawer>
  </div>
</template>

<style scoped>
.header {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
</style>
